export const caZipCodeFormatter = value => {
  value = value.toUpperCase();
  if (value.length == 7 && value.indexOf(' ') == 3) {
    // It's at least
    return value;
  }
  return `${value.substring(0, 3)} ${value.substring(3)}`;
};



// WEBPACK FOOTER //
// ./app/javascript/common/formatters/ZipCode.js